import React from "react";
import styled from "styled-components";
import Land1 from "./Land1";
import About from "../About";
import Tool from "../Tool"
import About2 from "../About2";
import Projects from "../Projects";
// import Contact from "../Contact"

const Home  = () => {
    return(
        <MainContainer>
            <Land1/>
            <About/>
            <Tool/>
            <About2/>
            <Projects/>
            {/* <Contact/> */}
        </MainContainer>
    )
};

export default Home;

const MainContainer = styled.div`
width: 100%;
height: max-content;
background-color: whitesmoke;
display: flex;
flex-direction: column;
/* padding-top: 90px; */

`;
